import request from '@/router/axios';

export function getUserListpage(obj) {
  return request({
    url: '/sys/user/page',
    method: 'POST',
    data: obj,
  });
}
/**
 *  根据id修改数据
 * @param obj
 */
export function updateListpage(obj) {
  return request({
    url: '/sys/user/update',
    method: 'put',
    data: obj,
  });
}

export function addListpage(obj) {
  return request({
    url: '/sys/user/add',
    method: 'post',
    data: obj,
  });
}
export function batchUpdateStatus(obj) {
  return request({
    url: '/sys/user/batchUpdate',
    method: 'post',
    data: obj,
  });
}
